import * as Sentry from '@sentry/react';
import { Route, Routes } from 'react-router-dom';

export const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);
export const SentryRoute = Sentry.withSentryReactRouterV6Routing(Route);
